//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PhoneInput",
  props: {
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    emitValue: Boolean,
    extension: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    }
  },
  computed: {
    mask() {
      if (!this.extension) return "(999) 999-9999";
      return "(999) 999-9999 Ext. [999999]";
    }
  },
  methods: {
    handleChange(event) {
      if (event.target.value && !event.target.inputmask.isComplete()) return;
      if (this.emitValue) {
        this.$emit("change", event.target.value);
      } else {
        this.$emit("change", event);
      }
    },
    valueUpdated({
      target: {
        value
      }
    }) {
      if (value && this.$refs.input.inputmask.isComplete()) {
        this.$emit("input", {
          phoneNumber: value,
          isValueValid: true
        });
      } else {
        this.$emit("input", {
          phoneNumber: value,
          isValueValid: false
        });
      }
    }
  }
});